import type { CSSProperties } from "react";
import totemRed from "../assets/brand/totem-red.svg";
import totemTeal from "../assets/brand/totem-teal.svg";
import totemTiki from "../assets/brand/totem-tiki.svg";
import logoMark from "../assets/brand/logo-mark.svg";

// Brand illustrations for three of eight totems; the rest fall back to
// the brand mark (a filled Maya mask) so the avatar stays visually
// on-brand even before the full illustration series arrives.
// See DESIGN §1.1.
const TOTEM_ART: Record<string, string> = {
  jaguar: totemRed,
  quetzal: totemTeal,
  monkey: totemTiki,
};

const TOTEM_LABELS: Record<string, string> = {
  jaguar: "Ягуар",
  quetzal: "Кетсаль",
  serpent: "Змей",
  monkey: "Обезьяна",
  iguana: "Игуана",
  tapir: "Тапир",
  hummingbird: "Колибри",
  crocodile: "Крокодил",
};

interface Props {
  code: string;
  size?: number;
  style?: CSSProperties;
}

export function Totem({ code, size = 56, style }: Props) {
  const label = TOTEM_LABELS[code] ?? "Тотем";
  const art = TOTEM_ART[code] ?? logoMark;
  return (
    <img
      src={art}
      width={size}
      height={size}
      alt={label}
      style={{ display: "block", ...style }}
    />
  );
}

export { TOTEM_LABELS };
